module.exports = __webpack_public_path__ + "static/media/matheson.0a0b0b73.png";